import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';

import IconButton from '@material-ui/core/IconButton';
import PersonIcon from '@material-ui/icons/Person';
import StarsIcon from '@material-ui/icons/Stars';
import StarIcon from '@material-ui/icons/Star';
import Fab from '@material-ui/core/Fab';

import { CONFIRM_DIALOG, CONTACT_DIALOG } from '../../../redux/constants/dialogs';
import { hasPermission } from '../../../utils/authenticated';
import { replaceOrAdd } from '../../../utils/helper';
import Grid from '../../Common/Grid/index';
import getNoDataCellComponent from '../../Common/NoDataCellComponent';
import { name } from '../../../utils/helper';

import styles from './styles';

const COLUMNS = [
  { name: 'primaryContact', title: ' ' },
  { name: 'name', title: 'Name' },
  { name: 'telephone', title: 'Telephone' },
  { name: 'mobile', title: 'Mobile' },
  { name: 'email', title: 'Email' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'primaryContact', width: 80 },
  // { columnName: 'name', width: 200 },
  // { columnName: 'mobile', width: 100 },
  // { columnName: 'email', width: 150 },
  { columnName: 'action', width: 80 },
];

const getCellComponent = (onSetPrimary) => ({ column, value, row }) => {
  switch (column.name) {
    case 'primaryContact':
      return row && row.primary ?
        <Tooltip title="Primary Contact"><StarIcon color="secondary" style={styles.primaryIcon}/></Tooltip> : null;
    case 'name':
      return name(row);
    case 'action':
      return !row || !row.primary ? (
        <Tooltip title="Set as primary contact"><IconButton tooltip="Set as Primary" onClick={() => onSetPrimary(row)}>
          <StarsIcon/>
        </IconButton></Tooltip>) : null;
    default:
      return value;
  }
};

// const getNoDataComponent = ({ children }) => {
//   return (<TableCell colSpan={children.length}>
//
//   </TableCell>);
// }

const noDataCellComponent = getNoDataCellComponent(<PersonIcon style={styles.noData}/>, 'contacts');

class ContactsGrid extends Component {
  state = {};

  componentWillMount() {
    this.setState({
      editable: hasPermission(['Administrator', 'JobCreator']),
    });
  }

  handleConfirmDelete = (contact) => {
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to remove this contact?',
        onConfirm: () => this.props.onChange(this.props.contacts.filter((c) => c.id !== contact.id)),
        onReject: reject,
      });
    });
  }

  handleSuccess = (contact) => {
    this.props.onChange(replaceOrAdd(this.props.contacts, contact));
  }

  handleSetPrimary = (contact) => {
    console.log('handleSetPrimary', contact);
    this.props.onChange(this.props.contacts.map((c) => {
      c.primary = c.id === contact.id;
      return c;
    }));
  }

  render() {
    const { contacts, showDialog } = this.props;

    const data = {
      data: contacts,
      pagination: {
        totalCount: contacts.length,
      },
    }

    const buttons = [<Tooltip key="create" title="Add Contact">
      <Fab
        color="secondary"
        aria-label="add"
        style={styles.add}
        onClick={() => showDialog(CONTACT_DIALOG, { contact: {}, onSuccess: this.handleSuccess })}
        size="small"
        id="addContact"
      >
        <AddIcon/>
      </Fab>
    </Tooltip>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      data={data}
      fetch={_.noop}
      onEdit={(contact) => this.props.showDialog(CONTACT_DIALOG, { contact, onSuccess: this.handleSuccess })}
      onRemove={this.handleConfirmDelete}
      cellComponent={getCellComponent(this.handleSetPrimary)}
      noDataCellComponent={noDataCellComponent}
    />);
  }
}

ContactsGrid.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  showDialog: PropTypes.func,
};

export default ContactsGrid;



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsGrid/index.js